import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';

@Component({
  selector: 'app-confirm-unlink',
  templateUrl: './confirm-unlink.component.html',
  styleUrls: ['./confirm-unlink.component.scss']
})
export class ConfirmUnlinkComponent implements OnInit {

  constructor(
    private dataService: DataService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    const userInfos = this.authService.getDecodedToken();
    setTimeout(() => {
      this.dataService.unlink.next(false);
      this.dataService.userIsLink.next(false);
    }, 2500);
  }

}
